// /agents DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정(레이아웃 결정성 확보, 헤더 잘림 해결).
// 넘치는 컬럼은 그리드 내부 가로 스크롤로 처리된다.

import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { EditButton } from "@refinedev/mui";
import { OverflowTooltip } from "components/list";
import { IAgent } from "../interfaces";

// 전화번호: 000-0000-0000 형태로 포맷 (현행 로직 유지)
const formatPhoneNumber = (value: unknown): string | null => {
  const phoneNumber = value as string | undefined;
  if (!phoneNumber) return null;
  return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
};

export const agentsColumns: GridColDef<IAgent>[] = [
  {
    field: "id",
    headerName: "ID",
    type: "number",
    width: 84,
    minWidth: 72,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "name",
    headerName: "이름",
    type: "string",
    width: 120,
    minWidth: 100,
  },
  {
    field: "loginId",
    headerName: "로그인ID",
    type: "string",
    width: 132,
    minWidth: 110,
  },
  {
    field: "phoneNumber",
    headerName: "전화번호",
    type: "string",
    width: 140,
    minWidth: 120,
    renderCell: (params: GridRenderCellParams) => (
      <OverflowTooltip value={formatPhoneNumber(params.value)} />
    ),
  },
  {
    field: "a_address",
    headerName: "주소",
    type: "string",
    width: 260,
    minWidth: 160,
  },
  {
    field: "sDate",
    headerName: "입사일",
    type: "string",
    width: 116,
    minWidth: 108,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "createdAt",
    headerName: "생성일",
    type: "string",
    width: 150,
    minWidth: 120,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "updatedAt",
    headerName: "수정일",
    type: "string",
    width: 236,
    minWidth: 190,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "actions",
    headerName: "Actions",
    width: 100,
    minWidth: 90,
    sortable: false,
    renderCell: (params: GridRenderCellParams) => (
      <EditButton hideText recordItemId={params.row.id} />
    ),
  },
];
